module.exports = __webpack_public_path__ + "img/part.8d47bc6f.svg";